<template>
    <el-button
        :size="size"
        :style="buttonStyle"
        @click="click"
        class=""
        :class="[minWidthContainer, dTheme]"
        :disabled="loading || disabled"
        :native-type="nativeType"
        >
        <div class="loading-button-with-loader__content">
            <main v-if="loading">
                <LineScaleLoaderV2 :size="linerSize" :theme="linerTheme" />
            </main>
            <slot v-if="!loading">
                
            </slot>
        </div>
    </el-button>
</template>

<script>
import LineScaleLoaderV2 from './LineScaleLoaderV2'
export default {
    props: {
        buttonStyle: {
            type: Object,
            default: () => {}
        },
        text: {
            type: String,
            default: () => 'Save'
        },
        loading: Boolean,
        linerTheme: {
            type: String,
            default: "light",
        },
        disabled: Boolean,
        size: {
            type: String,
            default: 'mini'
        },
        linerSize: {
            type: String,
            default: 'micro',
        },
        type: {
            type: String,
        },
        disabledTheme: {
            type: String,
            default: 'opacity', /* or default */
        },
        applyMinWidth: {
            type: Boolean,
            default: true,
        },
        nativeType: {
            type: String,
            default: 'submit',
        }
    },
    methods: {
        click(evt) {
            if(!this.loading) {
                this.$emit('click', evt)
            }
        },
    },
    computed: {
        dTheme() {
            if (!this.disabled) {
                return null
            }

            if (this.disabledTheme === 'opacity') {
                return 'loading-button-with-loader__blue--themeOpacity__disabled'
            } else if (this.disabledTheme === 'noChange') {
                return 'loading-button-with-loader__blue--themeNoChange__disabled'
            } else if (this.disabledTheme === 'color') {
                return 'loading-button-with-loader__blue--themeColor__disabled'
            } else {
                return 'loading-button-with-loader__blue--themeDefault__disabled'
            }
        },
        minWidthContainer() {
            if (this.applyMinWidth) {
                return 'loading-button-with-loader'
            }
            return null
        },
    },
}
</script>
<style lang="scss">
    .loading-button-with-loader{
        min-width: 150px;
        border-radius: 5px;
        height: 45px;
    }

    .loading-button-with-loader__blue {
        background-color: #004e96 !important;
        border: 1px solid #004e96 !important;
        color: #ffffff !important;
        font-size: 14px;

        &:hover{
            background-color: #003669 !important;
            color: #ffffff !important;
            border-color: #003669 !important;
        }
        &:focus{
            background-color: #003669 !important;
            color: #ffffff !important;
            border-color: #003669 !important;
        }
        &:active{
            color: #fff;
        }
    }

    .loading-button-with-loader__blue--themeDefault__disabled {
        background-color: #f2f2f2 !important;
        border: 1px solid #e6e6e6 !important;
        color: #999999 !important;
        &:disabled {
            cursor: not-allowed;
        }
        &:disabled:hover {
            cursor: not-allowed;
        }
    }

    .loading-button-with-loader__blue--themeColor__disabled {
        background-color: #004e96 !important;
        border: 1px solid #004e96 !important;
        color: #ffffff !important;
    }

    .loading-button-with-loader__blue--themeOpacity__disabled {
        opacity: 0.2 !important;
        &:disabled {
            cursor: not-allowed;
        }
        &:disabled:hover {
            cursor: not-allowed;
        }
    }

    .loading-button-with-loader__blue--themeNoChange__disabled {
        // opacity: 0.2 !important;
        &:disabled {
            cursor: not-allowed;
        }
        &:disabled:hover {
            cursor: not-allowed;
        }
    }

    .loading-button-with-loader__content {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        .loading-button__icon {
            position: absolute;
            right: -20px;
        }
    }
</style>
